/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Time_MorningInputs */

const en_ui_time_morning = /** @type {(inputs: Ui_Time_MorningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morning`)
};

const de_ui_time_morning = /** @type {(inputs: Ui_Time_MorningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`am Morgen`)
};

/**
* | output |
* | --- |
* | "Morning" |
*
* @param {Ui_Time_MorningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_time_morning = /** @type {((inputs?: Ui_Time_MorningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Time_MorningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_time_morning(inputs)
	return de_ui_time_morning(inputs)
});